import {
  ApiOnboardingStep,
  ApiProject,
  ApiSimpleOnboarding,
} from "@incendium/api";
import {
  Box,
  Button,
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import SpacedList from "Components/UI/SpacedList";
import { friendlyDate } from "Helpers/dates";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

interface IOnboardingListProps {
  items: ApiSimpleOnboarding[];
  projects: ApiProject[];
  onNew: () => void;
  onDelete: (item: ApiSimpleOnboarding) => void;
}
function OnboardingList({
  items,
  onNew,
  onDelete,
  projects,
}: IOnboardingListProps) {
  const history = useHistory();
  const getProject = useCallback(
    (item: ApiSimpleOnboarding) => {
      return projects.find((p) => p.id === item.projectId);
    },
    [projects]
  );
  const goToGetStarted = useCallback(
    (item: ApiSimpleOnboarding) => {
      const project = getProject(item);
      if (!project) {
        return;
      }
      history.push(
        `/clients/${project.clientId}/projects/${project.id}/get-started`
      );
    },
    [getProject, history]
  );

  return (
    <SpacedList
      title="Project Onboarding"
      action={<Button onClick={onNew}>New Onboarding</Button>}
    >
      <TableHead>
        <TableRow>
          <TableCell>Project</TableCell>
          <TableCell>Created On</TableCell>
          <TableCell>Published</TableCell>
          <TableCell>Approved</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {items.length === 0 && (
          <TableRow>
            <TableCell colSpan={4}>
              <Box p={2}>
                <Typography align="center">
                  Looks like you have no Projects with Onboarding setup yet.
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        )}
        {items.map((item) => (
          <TableRow key={item.id}>
            <TableCell>{getProject(item)?.name}</TableCell>
            <TableCell>{friendlyDate(item.createdAt)}</TableCell>
            <TableCell>
              {item.publishedDate
                ? `published on ${friendlyDate(item.publishedDate)}`
                : item.predictionsDone
                  ? `predictions done on ${friendlyDate(item.predictionsDone)}`
                  : "In Progress"}
            </TableCell>
            <TableCell>
              {item.approvedDate
                ? `approved on ${friendlyDate(item.approvedDate)}`
                : "Not Approved"}
            </TableCell>
            <TableCell width={100}>
              <Stack direction="row" spacing={1}>
                <Button
                  disabled={!item.predictionsDone}
                  size="extraSmall"
                  onClick={() => goToGetStarted(item)}
                >
                  Review
                </Button>
                <Button
                  color="secondary"
                  disabled={
                    item.uiStep !== ApiOnboardingStep.BASIC_INFO ||
                    !!item.publishedDate
                  }
                  size="extraSmall"
                  onClick={() => onDelete(item)}
                >
                  Delete
                </Button>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </SpacedList>
  );
}

export default OnboardingList;
